import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { Incoterm, IncotermFilters, IncotermDataForm } from '../../models/Incoterm';

const useIncotermService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetIncoterms, setFetchingGetIncoterms] = useState(false);
    const [fetchingStoreIncoterm, setFetchingStoreIncoterm] = useState(false);
    const [fetchingEditIncoterm, setFetchingEditIncoterm] = useState(false);
    const [fetchingUpdateIncoterm, setFetchingUpdateIncoterm] = useState(false);
    const [fetchingDeleteIncoterm, setFetchingDeleteIncoterm] = useState(false);
    const [fetchingActiveIncoterm, setFetchingActiveIncoterm] = useState(false);

    const getIncoterms = (filters: IncotermFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== undefined && value !== '' && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.INCOTERMS.GET_INCOTERMS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetIncoterms
        });
    };

    const storeIncoterm = (incoterm: IncotermDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.INCOTERMS.STORE_INCOTERM,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: incoterm,
            setFetching: setFetchingStoreIncoterm
        });
    };

    const editIncoterm = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.INCOTERMS.EDIT_INCOTERM.replace(':id', id.toString()),
            setFetching: setFetchingEditIncoterm
        });
    };

    const updateIncoterm = (id: number, incoterm: IncotermDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.INCOTERMS.UPDATE_INCOTERM.replace(':id', id.toString()),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: incoterm,
            setFetching: setFetchingUpdateIncoterm
        });
    };

    const deleteIncoterm = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.INCOTERMS.DELETE_INCOTERM.replace(':id', id.toString()),
            setFetching: setFetchingDeleteIncoterm
        });
    };

    const activeIncoterm = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.INCOTERMS.ACTIVE_INCOTERM.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActiveIncoterm
        });
    };

    return {
        fetchingGetIncoterms,
        fetchingStoreIncoterm,
        fetchingEditIncoterm,
        fetchingUpdateIncoterm,
        fetchingDeleteIncoterm,
        fetchingActiveIncoterm,
        getIncoterms,
        storeIncoterm,
        editIncoterm,
        updateIncoterm,
        deleteIncoterm,
        activeIncoterm
    };
};

export default useIncotermService;
